import { Box, Typography } from "@mui/material";
import { IShippingDest } from "../../types/client_detail";

const styles = {
  labelProps: {
    fontWeight: "bold",
    fontSize: { xs: 16, md: 18, lg: 20 },
    color: "var(--black)",
    lineHeight: "48px",
    height: "48px",
    padding: "0 18px",
    bgcolor: "var(--primary-500)",
    minWidth: { xs: "180px" },
    width: { xs: "180px" },
  },
  dataProps: {
    fontSize: { xs: 16, md: 18, lg: 20 },
    color: "var(--black)",
    lineHeight: "48px",
    height: "48px",
    padding: "0 18px",
  },
};

interface IClientInfoProps {
  addressList: IShippingDest[];
}

/**
 * `ClientInfo` is a React functional component that displays client information.
 * It uses Material-UI's `Box` and `Typography` components to layout and style the content.
 *
 * The component displays the following information:
 * - Client Information (得意先情報)
 * - Client Code (15425)
 * - Branch Code (支店コード)
 * - Client Name (得意先名)
 * - Store Name (ジョイフル北店)
 *
 * The layout is responsive, adjusting the maximum height and margin based on the screen size.
 *
 * @returns {Element} A JSX element containing the client information.
 */
function ClientInfo({ addressList }: IClientInfoProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      maxHeight={{ xs: "auto", md: "100%" }}
      mx={{ xs: "auto", md: "0" }}
      width={{xs: "100%", lg: 675 }}
    >
      <Box display="flex" mt={5}>
        <Box>
          <Typography {...styles.labelProps} textAlign="center">
            得意先コード
          </Typography>
          <Typography {...styles.dataProps} textAlign="center">
            {addressList[0]?.mst_client.client_cd}
          </Typography>
        </Box>
        <Box ml="6.5px">
          <Typography {...styles.labelProps} textAlign="center">
            支店コード
          </Typography>
          <Typography {...styles.dataProps} textAlign="center">
            {addressList[0]?.mst_yh_store_client.store_cd}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography {...styles.labelProps} textAlign="left" width="full" pl={6}>
          得意先名
        </Typography>
        <Typography {...styles.dataProps} pl={6}>
          {addressList[0]?.mst_client.client_name}
        </Typography>
      </Box>
    </Box>
  );
}

export default ClientInfo;
